import { normalizeLocale } from '@/i18n/localeCatalog';

const pick = (locale, vi, en, zh) => {
  const id = normalizeLocale(locale);
  if (id === 'en') return en;
  if (id === 'zh') return zh;
  return vi;
};

/**
 * Cấu hình shell dashboard theo role + ngôn ngữ (một nguồn cho mọi route).
 * @param {string} [role]
 * @param {string} [locale]
 */
export function getRoleDashboardConfig(role, locale = 'vi') {
  const L = (vi, en, zh) => pick(locale, vi, en, zh);

  if (role === 'teacher') {
    return {
      appTitle: 'QuizAtelier',
      systemTagline: L('Studio giáo viên', 'Teacher Studio', '教师工作台'),
      roleLabel: L('Giáo viên', 'Teacher', '教师'),
      menuItems: [
        { id: 'my-quizzes', icon: 'library_books', label: L('Quiz của tôi', 'My Quizzes', '我的测验'), path: '/quizzes/manage' },
        { id: 'classes', icon: 'school', label: L('Lớp học', 'Class', '班级'), path: '/classes' },
        { id: 'students', icon: 'group', label: L('Học sinh', 'Students', '学生') },
        { id: 'analytics', icon: 'analytics', label: L('Phân tích', 'Analytics', '分析') },
        { id: 'history', icon: 'history', label: L('Lịch sử làm bài', 'Quiz history', '测验历史'), path: '/history' },
      ],
    };
  }

  if (role === 'parent') {
    return {
      appTitle: 'QuizAtelier',
      systemTagline: L('Cổng phụ huynh', 'Parent Portal', '家长门户'),
      roleLabel: L('Phụ huynh', 'Parent', '家长'),
      menuItems: [
        { id: 'children', icon: 'family_restroom', label: L('Con cái / liên kết', 'Children', '子女 / 关联'), path: '/children' },
        { id: 'progress', icon: 'trending_up', label: L('Tiến độ của con', "Child's progress", '孩子学习进度') },
        { id: 'schedule', icon: 'calendar_today', label: L('Lịch học / kiểm tra', 'Schedule & tests', '课表 / 考试') },
        { id: 'messages', icon: 'chat', label: L('Tin nhắn với GV', 'Messages to teacher', '给教师留言') },
        { id: 'resources', icon: 'folder_shared', label: L('Tài liệu hỗ trợ', 'Resources', '学习资料') },
        { id: 'history', icon: 'history', label: L('Lịch sử làm bài', 'Quiz history', '测验历史'), path: '/history' },
      ],
    };
  }

  if (role === 'admin' || role === 'super_admin') {
    return {
      appTitle: 'QuizAtelier',
      systemTagline: L('Quản trị hệ thống', 'System admin', '系统管理'),
      roleLabel: L('Quản trị', 'Admin', '管理员'),
      menuItems: [
        { id: 'users', icon: 'group', label: L('Người dùng', 'Users', '用户') },
        { id: 'quizzes', icon: 'quiz', label: L('Quản lý quiz', 'Quiz management', '测验管理'), path: '/quizzes/manage' },
        { id: 'reports', icon: 'bar_chart', label: L('Báo cáo', 'Reports', '报表') },
        { id: 'tickets', icon: 'confirmation_number', label: L('Ticket hỗ trợ', 'Support tickets', '支持工单') },
        { id: 'history', icon: 'history', label: L('Lịch sử làm bài', 'Quiz history', '测验历史'), path: '/history' },
      ],
    };
  }

  return {
    appTitle: 'QuizAtelier',
    systemTagline: L('Học viện', 'Academy', '学院'),
    roleLabel: L('Học sinh', 'Student', '学生'),
    menuItems: [
      { id: 'classes', icon: 'school', label: L('Lớp học', 'Class', '班级'), path: '/classes' },
      { id: 'children-link', icon: 'family_restroom', label: L('Liên kết phụ huynh', 'Parent link', '关联家长'), path: '/children' },
      { id: 'tasks', icon: 'assignment', label: L('Bài tập được giao', 'Assigned work', '布置的作业') },
      { id: 'practice', icon: 'fitness_center', label: L('Tự luyện tập', 'Self-practice', '自主练习'), path: '/quizzes/manage' },
      { id: 'achievements', icon: 'military_tech', label: L('Thành tích', 'Achievements', '成就') },
      { id: 'history', icon: 'history', label: L('Lịch sử làm bài', 'Quiz history', '测验历史'), path: '/history' },
    ],
  };
}
